<template>
  <div>
    <Table :show-header='false' :columns="columns" :data="row" id="tableBorder" :width='1506'></Table>
  </div>
</template>
<script>
export default {
  props: {
      row: Array
  },
  data () {
    return {
       columns: [
          {
            title: "操作",
            align: "center",
            width: 100,
          },
          {
            title: "房间id",
            align: "center",
            width: 100,
            key: "roomId"
          },
          {
            title: "房间名称",
            align: "center",
            width: 120,
            key: "roomName"
          },
          {
            title: "城市",
            align: "center",
            width: 120,
            key: "associatedCityName"
          },
          {
            title: "物品id",
            align: "center",
            width: 100,
            key: "goodsId"
          },
          {
            title: "物品名称",
            align: "center",
            width: 120,
            key: "goodsName"
          },
          {
            title: "物料编号",
            align: "center",
            width: 130,
            key: "stockNumber"
          },
          {
            title: "一级类别",
            align: "center",
            width: 115,
            key: "goodsCatalog",
            render: (h, params) => {
            const status = [
              "",
              "个护用品",
              "布草",
              "家电",
              "家具 ",
              "家居装饰",
              "其他 ",
            ][params.row.goodsCatalog];
            return h("span", {}, status);
          }
          },
          {
            title: "规格",
            align: "center",
            width: 100,
            key: "goodsDesc"
          },
          // {
          //   title: "期初单价",
          //   align: "center",
          //   width: 120,
          //   key: "beginPrice",
          //   render: (h, p) => {
          //     return h("span", this.initPrice(p.row.beginPrice));
          //   }
          // },
          {
            title: "期初数量",
            align: "center",
            width: 100,
            key: "beginNum"
          },
          // {
          //   title: "期初金额",
          //   align: "center",
          //   width: 120,
          //   key: "beginMoney",
          //   render: (h, p) => {
          //     return h("span", this.initPrice(p.row.beginMoney));
          //   }
          // },
          // {
          //   title: "入库单价",
          //   align: "center",
          //   width: 120,
          //   key: "storageUnitPrice",
          //   render: (h, p) => {
          //     return h("span", this.initPrice(p.row.storageUnitPrice));
          //   }
          // },
          {
            title: "入库数量",
            align: "center",
            width: 100,
            key: "storageSum"
          },
          // {
          //   title: "入库金额",
          //   align: "center",
          //   width: 120,
          //   key: "storageMoney",
          //   render: (h, p) => {
          //     return h("span", this.initPrice(p.row.storageMoney));
          //   }
          // },
          // {
          //    title: "出库单价",
          //   align: "center",
          //   width: 120,
          //   key: "outboundPrice",
          //   render: (h, p) => {
          //     return h("span", this.initPrice(p.row.outboundPrice));
          //   }
          // },
          {
             title: "出库数量",
            align: "center",
            width: 100,
            key: "outboundSum"
          },
          {
             title: "金额",
            align: "center",
            width: 100,
            key: "outboundMoney",
            render: (h, p) => {
              return h("span", 
              this.initPrice ? this.initPrice(p.row.outboundMoney) : '-');
            }
          },
          // {
          //   title: "期末单价",
          //   align: "center",
          //   width: 120,
          //   key: "endPrice",
          //   render: (h, p) => {
          //     return h("span", this.initPrice(p.row.endPrice));
          //   }
          // },
          {
            title: "期末数量",
            align: "center",
            width: 100,
            key: "endSum"
          },
          // {
          //   title: "期末金额",
          //   align: "center",
          //   width: 120,
          //   key: "endMoney",
          //   render: (h, p) => {
          //     return h("span", this.initPrice(p.row.endMoney));
          //   }
          // }
        ]
    }
  },
  methods: {
    initPrice(val) {
      return (val/100).toFixed(2)
    }
  }
};
</script>
<style lang="scss" scoped>
.expand-row{
    margin-bottom: 16px;
}
#tableBorder{
  border: 0 !important;
  tr{
    border: 0 !important;
  }
  td{
    border: 0 !important;
    padding: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/table-inventory.vue